export const table = {
  periodText: {
    display: "inline",
    fontSize: "1.5rem",
    "@media screen and (max-width: 767px)": {
      fontSize: "1.25rem",
    },
    "@media screen and (max-width: 479px)": {
      fontSize: ".875rem",
    },
  },
  priceText: {
    fontWeight: "700",
    fontSize: "3.5rem",
    wordBreak: "break-word",
    "@media screen and (max-width: 991px)": {
      fontSize: "3.25rem",
    },
    "@media screen and (max-width: 767px)": {
      fontSize: "2.5rem",
    },
    "@media screen and (max-width: 479px)": {
      fontSize: "1.5rem",
    },
  },
};
